import React, { Component } from 'react';
import { Container, Menu, Icon, Segment, Header, Grid, Button } from 'semantic-ui-react';

import './App.css';
import 'semantic-ui-css/semantic.min.css';

import { Demo } from './Demo';
import { Mailing } from './Mailing';

class App extends Component {
    render() {
        return (
            <div className="pusher">
                <Segment vertical className="masthead">
                    <Container text>
                        <Menu secondary pointing size="large">
                            <Menu.Item href="/" header>
                                dicted.io
                            </Menu.Item>
                            <Menu.Menu position="right">
                                <Menu.Item href="https://www.facebook.com/Dicted-116623808943889" target="_blank">
                                    <Icon name="facebook f" link />
                                </Menu.Item>
                                <Menu.Item href="https://twitter.com/dictedio" target="_blank">
                                    <Icon name="twitter" link />
                                </Menu.Item>
                            </Menu.Menu>
                        </Menu>
                    </Container>
                    <Grid stackable columns={2} textAlign="center" verticalAlign="middle" container>
                        <Grid.Row >
                            <Grid.Column className="title">
                                <Header as="h1">
                                    Stop typing.<br />Start creating.
                                </Header>

                                <p>It doesn't matter if you are <em>telling a story</em>, <em>expressing</em> your feelings or <em>teaching</em> a new skill. Capture your thoughts by saying them out loud in <em className="logo">dicted.io</em>.</p> 
                                <Mailing />
                           </Grid.Column>

                            <Demo />
                        </Grid.Row>
                    </Grid>
                </Segment>

                <Segment vertical className="stripe users">
                    <Grid container stackable columns="equal">
                        <Grid.Row textAlign="center" columns={1}>
                            <Grid.Column>
                                <Header as="h1">Who's this for?</Header>
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row verticalAlign="top" columns="equal">
                            <Grid.Column>
                                <Segment basic>
                                <Header as="h3">
                                    Bloggers
                                </Header>

                                <p>When you are trying to write on a schedule, every minutes counts. Don't waste your time trying to write as fast as you can, when you can just say what you think. Don't worry about <strike>you're</strike> your spelling anymore, we've got you covered. </p>
                                
                                <p><em className="logo">dicted.io</em> shatters the speed limits of typing, by dropping it entirely. Say what you think and have it published within minutes. Did we mention that <em className="logo">dicted.io</em> handles the publishing to popular blog platforms for you?</p>
                                </Segment>
                            </Grid.Column>

                            <Grid.Column>
                                <Segment basic>
                                <Header as="h3"> Journalists </Header>

                                <p>Deadlines are one hell of a beast, so why do you still spend your precious time in front of the screen? This is not where the things happen, so get out of the room, tell what you see and have it taken down.</p>
                                
                                <p><em className="logo">dicted.io</em> works in the browser, so you can use it anywhere where you have access to a computer with an access to the internet (applications dedicated to devices coming soon, too!). Don't worry about having your notepad anywhere with you anymore!</p>
                                </Segment>
                                
                            </Grid.Column>
                                
                            <Grid.Column>
                                <Segment basic>
                                <Header as="h3">Writers</Header>

                                <p>You have enough on your plate working on your <em>opus magnum</em>. Keeping all those characters, places, plots and events in sync and avoiding loopholes is hard enough, so why are you wasting your energy on mashing those keys? Why do you strain your eyes and back staring at the screen, when you could sit comfortably in your favorite sofa with a mug of hot chocolate and tell your story?</p>
                                <p>With <em className="logo">dicted.io</em> you can finally focus on storytelling, stepping back from the screen and weaving the web of plots. That means getting rid of all the distractions from your environment, so no more excuses!</p>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        
                   </Grid>
                </Segment>

                <Segment vertical basic className="upbutton">
                    <Button content="I want to learn more"
                            icon="angle double up"
                            color="blue"
                            size="huge"
                            href="#top"
                            fluid
                            />
                </Segment>

                <Segment vertical>
                    <Grid divided='vertically' columns="4" centered > 
                        <Grid.Column textAlign="center">
                            <Grid.Row>
                                    <Segment vertical>
                                        <Header as="h3">
                                            <Icon name="unmute" />
                                        </Header>

                                        <p>Create your texts by saying them out loud. Have the technology powering popular voice assistants handle the rest for you.</p>
                                    </Segment>
                            </Grid.Row>                
                
                            <Grid.Row>
                                <Segment vertical>
                                    <Header as="h3">
                                        <Icon name="cloud" />
                                    </Header>
                                    
                                    <p>Store everything safely in the cloud. Access and modify anywhere and anytime you need.</p>
                                </Segment>
                            </Grid.Row>                

                            <Grid.Row>
                                <Segment vertical>
                                    <Header as="h3">
                                        <Icon name="send" />
                                    </Header>
                                    
                                    <p>Share easily with whoever you want. Export your texts to popular blog platforms and enough file formats so everyone will be able to enjoy.</p>
                                </Segment>
                            </Grid.Row>                
                        </Grid.Column>
                    </Grid>
                </Segment>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js